var Booking = (function(window, document, $, undefined) {

    "use strict";

    // Define some variables
    var _SETTINGS_, _DATA_, _STATES_;

    // Common settings
    _SETTINGS_ = {
        ajaxUrl: CCM_REL + '/index.php/tools/packages/calendar/ajax.php'
    };

    // Data collected from various (external) sources
    _DATA_ = {
        categories: [],
        visitor: {}
    };

    // Collection of module states
    _STATES_ = {
        // Holds a list of currently applied filters
        filtered: [],
        // Keeps track of which sorting is applied
        sort: 'SORT_DISTANCE',
        sortDirection: "asc",
        defaultSort: "SORT_DISTANCE",
        defaultSortDirection: "asc",
        // Keeps a reference of the current locations shown, and is used
        // when sorting is applied
        categories: [],
        // Keeps track of the current search query and its location result
        search: {
            query: '',
            radius: 0,
            location: ''
        },
        limited: true
    };

    // Preferences supplied by the backend service. The values below
    // act as defaults but are overridden with the backend response
    var preferences = {
        instance_id: null,
        text_messaging_on: 1,
        max_items: 5,
        // Boundaries supplied by the backend
        boundary_east: null,
        boundary_west: null,
        boundary_north: null,
        boundary_south: null,
        // Units can either be 'km' or 'mi'
        measurement_unit: 'km',
        radius_options: ''
    };

    // The current location of the visitor
    var visitorLocation = null;

    // Geocoder instance
    var geocoder = new google.maps.Geocoder();

    // Instance of the current bounds, used to limit autocomplete search results
    var boundsInstance = null;
    var initialBoundsInstance = null;

    // The AutoComplete google service instance
    var autocompleteService = null,
        autocompleteOptions = {
            types: ['geocode'],
            // @todo maybe handy in the future?
            // componentRestrictions: {country: 'au'}
        };

    // Elements
    var $el = $('.store-locator'),

        // Container of all filters
        $filterListContainer = $el.find('#storeLocatorFilterList'),

        // Search related elements
        $searchForm = $el.find('#storeLocatorSearchForm'),
        $searchQuery = $el.find('#storeLocatorQuery'),
        $searchRadiusValue = $el.find('#storeLocatorRadiusValue'),
        $searchRadiusSelect = $el.find('#storeLocatorRadius'),
        $searchRadiusOptions = $el.find('#storeLocatorRadiusOptions'),

        // Provider list results and template
        $resultsListContainer = $el.find('#storeLocatorResultsList'),
        $storeLocatorMoreLink = $el.find('#storeLocatorMoreLink');

    if ($('#resultsListTemplate').length > 0) {
        var resultsListTemplate = _.template($('#resultsListTemplate').html());
    }

    // The instanceId and categoryId used to collect data from the api
    var instanceId = $el.attr('data-instance-id'),
        categoryId = $el.attr('data-category-id'),
        netsuiteProviderSiteId = $el.attr('data-netsuite-provider-site-id');

    // Class Selectors
    var optionClass = '.store-locator-option';

    // Initialisation
    // --------------------------------------------------

    /**
     * Public initializer
     * @return {void}
     */
    function init() {
        if ($searchForm.length) {
            // First, load all required instance data
            loadInstanceData()
                .done(function(response) {
                    // Keep a reference of the response data
                    _DATA_.categories = response.categories;
                    _DATA_.visitor = response.visitor;
                    // Define the visitor location
                    visitorLocation = new google.maps.LatLng(response.visitor.point.lat, response.visitor.point.lng);

                    // Set the preferences, if supplied
                    if (_.isObject(response.preferences)) {
                        preferences = _.extend({}, preferences, response.preferences);
                    }

                    // If we don't have a categoryId, then don't limit the results. This is done to determine
                    // if we are running as a tool, or as a module.
                    // JH: in Open Enrolment, we DO use max_items
                    if (typeof categoryId === 'undefined') {
                        // preferences.max_items = 9999;
                    }

                    // Initialize the search function
                    initSearch();

                    // Initialize and render the filters
                    initFilters();

                    // Events
                    bindEvents();

                    // make sure the radius is set
                    $searchRadiusSelect.change();

                    // Render the results
                    render();
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    // alert('Failed to load instance data: ' + errorThrown);
                });
        }
    }

    /**
     * Initializes search related logic
     * @return {void}
     */
    function initSearch() {

        var radiusOptions = '';

        // Add the radius select options
        $searchRadiusValue.text(preferences.measurement_unit);
        $searchRadiusSelect.html(preferences.radius_options);

        // Update the custom dropdown with the values from the select element
        $.map($('option', $searchRadiusSelect), function(option) {
            // radiusOptions += '<li><a href="#" data-option-value="' + option.value + '">' + option.value + ' ' + preferences.measurement_unit + '</a></li>';
            radiusOptions += '<li><a href="#" data-option-value="' + option.value + '">' + option.text + '</a></li>';
        });

        $searchRadiusOptions.find('.dropdown-menu').html(radiusOptions);

        // Make sure the select button has the correct default value
        // $searchRadiusValue.text($('option:selected', $searchRadiusSelect).val() + ' ' + preferences.measurement_unit);
        $searchRadiusValue.text($('option:selected', $searchRadiusSelect).text());

        // Define the autocomplete service
        autocompleteService = new google.maps.places.Autocomplete($searchQuery[0], autocompleteOptions);

        // Define and set the boundaries if we are one a Stap Positive site instance
        var sw = new google.maps.LatLng(preferences.boundary_south, preferences.boundary_west);
        var ne = new google.maps.LatLng(preferences.boundary_north, preferences.boundary_east);
        initialBoundsInstance = boundsInstance = new google.maps.LatLngBounds(sw, ne);
        // Set the bounds to where autocomplete requests are mapped
        autocompleteService.setBounds(boundsInstance);
    }

    /**
     * Renders the filters based on the backend data
     * @return {void}
     */
    function initFilters() {

        // If the filters are not visible, just add the id's to the filter state so
        // they are always applied.
        if (!$filterListContainer.length) {
            _.each(_DATA_.categories, function(category) {
                _STATES_.filtered.push(parseInt(category.id));
            });
            return;
        }

        // Get the template
        var filtersTemplate = _.template($('#filtersTemplate').html());
        // Render the template based on the filters
        var compiled = filtersTemplate({ filters: _DATA_.categories });
        $filterListContainer.html(compiled);

        // Make sure all filters are checked by default, but don't trigger a change event just yet
        $.map($filterListContainer.find('input'), function(el) {
            var $el = $(el);
            $el.prop('checked', true).parent().addClass('checked');
            _STATES_.filtered.push($el.data('filter-id'));
        });

    }

    function EqualizeFilterHeights() {
        // Makes sure each filter item on a row of four have equal height.
        // Only apply this on desktop views since views below this threshold have all
        // filters aligned vertically.
        if ($(window).width() >= 992) {
            var i = 0,
                height, highest = [],
                row;
            $('.store-locator-filter-item').each(function() {
                var $item = $(this),
                    height = $item.height(),
                    row = Math.floor(i / 4);
                if (highest[row] === undefined || highest[row] < height) { highest[row] = height; }
                $item.addClass('filter-item-row-' + row);
                i++;
            });
            $.each(highest, function(row, height) {
                $('.filter-item-row-' + row).height(height);
            });
        }
    }

    /**
     * Binds common events to the module
     * @return {void}
     */
    function bindEvents() {

        var $doc = $(document);

        $doc.on('click', '.store-locator-option-trigger', function(e) {
            e.preventDefault();
            var target = $(e.currentTarget).parents(optionClass);
            toggleOption(target);
        });

        // Filters
        $doc.on('click', '.store-locator-filter-button', function(e) {
            e.preventDefault();
            var el = $(e.currentTarget);
            toggleFilters(el.data('state'));
        });

        $doc.on('change', '.store-locator-filter-item input', function(e) {
            e.preventDefault();
            var el = $(e.currentTarget);
            toggleFilter(el);
        });

        // Results
        $doc.on('click', '.store-locator-result-item', function(e) {
            e.preventDefault();
        });

        $doc.on('click', '.store-locator-result-item a', function(e) {
            e.stopPropagation();
        });

        $doc.on('click', '.store-locator-result-tabs a', function(e) {
            e.preventDefault();
            _STATES_.sort = $(this).data('sort');
            _STATES_.sortDirection = $(this).is(".active") ? _STATES_.sortDirection == "asc" ? "desc" : "asc" : "asc";
            $(this).removeClass("sort-asc sort-desc").addClass('active sort-' + _STATES_.sortDirection).parent().siblings().find('a').removeClass('active sort-asc sort-desc');
            render();
        });

        $doc.on('click', '.booking-result-more', function(e) {
            e.preventDefault();
            _STATES_.limited = !_STATES_.limited;
            if (_STATES_.limited) {
                $(this).html('<span>Show more courses</span>').attr('data-state', 'more');
            } else {
                $(this).html('<span>Show less courses</span>').attr('data-state', 'less');
            }
            render();
        });

        // Search
        // @todo hide this if not available in old browsers?
        $doc.on('click', '.store-locator-location', function(e) {
            var boundsRadius;
            e.preventDefault();
            getVisitorLocation()
                .done(function(position) {
                    _STATES_.search.location = visitorLocation = position;
                    // try to get a circle based on the radius
                    boundsRadius = getBoundsByRadius(visitorLocation);
                    if (boundsRadius) // a radius of 0 means what exactly?
                        boundsInstance = boundsRadius;
                    else
                        boundsInstance = initialBoundsInstance;
                    render();
                })
                .fail(function(error) {
                    alert("Your browser couldn't provide us with your location, so we will use a default location");
                    _STATES_.search.location = visitorLocation = new google.maps.LatLng(_DATA_.visitor.point.lat, _DATA_.visitor.point.lng);
                    // try to get a circle based on the radius
                    boundsRadius = getBoundsByRadius(visitorLocation);
                    if (boundsRadius) // a radius of 0 means what exactly?
                        boundsInstance = boundsRadius;
                    else
                        boundsInstance = initialBoundsInstance;
                    render();
                });
        });

        $searchRadiusSelect.on('change', function(e) {
            var selectedOptionValue = e.target.value;
            _STATES_.search.radius = selectedOptionValue;
            $searchRadiusValue.text($(e.target).find('option:selected').text());
        });

        $searchRadiusOptions.find('.dropdown-menu a').on('click', function(e) {
            e.preventDefault();
            var targetEl = $(e.currentTarget);
            $searchRadiusSelect.val(targetEl.data('option-value')).trigger('change');
        });

        $searchForm.on('submit', function(e) {
            e.preventDefault();
            _STATES_.sort = _STATES_.defaultSort;
            _STATES_.sortDirection = _STATES_.defaultSortDirection;
            $doc.find('.store-locator-result-tabs a').each(function() {
                if ($(this).data('sort') == _STATES_.sort)
                    $(this).removeClass("sort-asc sort-desc").addClass('active sort-' + _STATES_.sortDirection);
                else
                    $(this).removeClass('active sort-asc sort-desc');
            });
            search($searchQuery.val());
        });

        $searchQuery.on('click', function(e) {
            $searchQuery.val('');
        });
    }

    // Rendering
    // --------------------------------------------------

    /**
     * Search within the supplied list of categories
     * @param  {string} address The string to search for
     * @return {void}
     */
    function search(query) {
        var closestLocation, calculatedZoom, calculatedBounds, boundsRadius;

        // Update the current search query state
        _STATES_.search.query = query;

        if (query.length) {
            // Geocode the supplied string
            geocodeLocation(query)
                .done(function(result) {

                    // Store the found location in the search state array
                    _STATES_.search.location = result.geometry.location;

                    // Update the visitor location with the search result. Distance calculation
                    // will from this point on be based on this result location
                    visitorLocation = result.geometry.location;

                    // try to get a circle based on the radius
                    boundsRadius = getBoundsByRadius(visitorLocation);
                    if (boundsRadius) // a radius of 0 means what exactly?
                        boundsInstance = boundsRadius;
                    else
                        boundsInstance = initialBoundsInstance;

                    render();
                })
                .fail(function(response) {
                    alert('Sorry! We could not find a location for your search query: ' + response);
                });
        } else {
            boundsInstance = initialBoundsInstance;
            render();
        }

    }

    /**
     * Renders the results
     * @return {void}
     */
    function render() {

        // Define variables
        var categories = _DATA_.categories.slice(),
            details;

        // Apply filtering on the categories
        details = filterAndSearchCategories(categories);

        // Apply sorting on remaining details
        details = sortDetails(details);

        // If the number of details is larger than the max_items preference, then
        // limit the results and show the 'Show more'
        if (details.length > preferences.max_items) {
            $storeLocatorMoreLink.toggleClass('hide', false);
            if (_STATES_.limited) details = details.slice(0, preferences.max_items);
        } else {
            $storeLocatorMoreLink.toggleClass('hide', true);
        }
        renderList(details);

    }

    /**
     * Renders the list of sessions, based on supplied sessions
     * @param  {array} details List of sessions to render
     * @return {void}
     */
    function renderList(details) {
        if (!details) {
            var categories = _DATA_.categories.slice();

            // Apply filtering on the categories
            details = filterAndSearchCategories(categories);

            // Apply sorting on remaining details
            details = sortDetails(details);
        }
        // Internally sets the current details. This is used to provide easy sorting
        // on an existing dataset
        _DATA_.details = details;

        // Render the map and list
        var compiled = resultsListTemplate({ details: details, unit: preferences.measurement_unit });
        $resultsListContainer.html(compiled);

    }

    // States
    // --------------------------------------------------

    /**
     * Toggles the option
     * @param  {object} el The element to toggle
     * @return {void}
     */
    function toggleOption(el) {
        el.toggleClass('opened');
    }

    /**
     * Check of uncheck a single filter
     * @param  {object} el The filter item
     * @return {void}
     */
    function toggleFilter(el) {
        var checked = el.prop('checked'),
            filter = el.data('filter-id'),
            idx;
        el.parent().toggleClass('checked', checked);
        // Either add or remove the filter from the filtered state
        if (checked) {
            _STATES_.filtered.push(filter);
        } else {
            idx = _STATES_.filtered.indexOf(filter);
            if (idx != -1) { _STATES_.filtered.splice(idx, 1); }
        }
        render();
    }

    /**
     * Either checks or unchecks all filters
     * @param  {bool} state Whether to check of uncheck
     * @return {void}
     */
    function toggleFilters(state) {
        // Update the checkbox elements
        $filterListContainer.find('input').prop('checked', state).parent().toggleClass('checked', state);
        // Update the filtered array, used when filtering locations
        if (state === false) {
            _STATES_.filtered = [];
        } else {
            _STATES_.filtered = [];
            // _.each(_DATA_.filters, function(filter) { _STATES_.filtered.push(parseInt(filter.level_id)); });
            _.each(_DATA_.categories, function(category) {
                _STATES_.filtered.push(parseInt(category.id));
            });
        }
        render();
    }

    /**
     * Opens or closes a provider item
     * @param  {object} el The item to toggle
     * @return {void}
     */
    function toggleResultItem(el) {
        // TODO: check if this is still required. Probably not..
        // el.toggleClass('opened');
        // el.siblings().removeClass('opened');
    }

    // Helpers
    // --------------------------------------------------

    /**
     * Filters categories based on current filters and the map bounds
     * @param  {array} arr Array of categories to filter
     * @return {Array}
     */
    function filterAndSearchCategories(categories) {

        // Define variables
        var category, details = [],
            filtered, searched, results;

        // Walk through each category and filter out any
        for (var i = categories.length - 1; i >= 0; i--) {
            category = categories[i];
            filtered = true;
            // Only filter when filters are selected. If no filters are selected, all
            // categorys will be filtered out
            if (_STATES_.filtered.length > 0) {
                if (_STATES_.filtered.indexOf(parseInt(category.id)) !== -1) {
                    filtered = false;
                }
            }
            // If none of the above checks passed, filter out the category
            filtered && categories.splice(i, 1);
        }

        // If we have no more categories left, then just return an empty array
        if (!categories.length) {
            _DATA_.details = [];
            return [];
        }

        // Now, extract all details from the categories so we can apply the search query
        details = extractDetailsFromCategories(categories);

        // If no search query is supplied, return the details as-is
        if (!_STATES_.search.query.length && !_STATES_.search.location) {
            _DATA_.details = details;
            return details;
        }

        console.dir(_STATES_.search);

        if (_STATES_.search.location) {
            var detail, position;
            for (var i = details.length - 1; i >= 0; i--) {
                detail = details[i];
                position = new google.maps.LatLng(detail.lat, detail.lng);

                if (boundsInstance === null || boundsInstance.contains(position)) {
                    detail.distance = getDistanceBetween(new google.maps.LatLng(detail.lat, detail.lng), visitorLocation);
                } else {
                    details.splice(i, 1);
                }
            }
            _DATA_.details = details;
            return details;
        } else {

            // Use the sifter lib to search in the details array
            var sifter = new Sifter(details);
            searched = sifter.search(_STATES_.search.query, {
                // The keys to search in
                fields: ['city_town', 'field_when_line1', 'field_when_line2', 'state_county', 'title', 'venue_location'],
                // Sorting (which is overridden at sortDetails)
                sort: [{ field: 'title', direction: 'asc' }],
                // Always return the full set of results. Limiting happens in the render method
                limit: 9999
            });

            // No results, return an empty array
            if (!searched.total) return [];

            // Get all details based on the found items
            _DATA_.details = _.map(searched.items, function(item) {
                return details[item.id];
            });
            return _DATA_.details;
        }
    }

    /**
     * Sorts details based on current sort state
     * @param  {Array}
     * @return {Array}
     */
    function sortDetails(arr) {
        var order = _STATES_.sortDirection == "desc" ? "-" : "";
        // Sort the result based on the default sort
        switch (_STATES_.sort) {
            case 'SORT_WHAT':
                arr.sort(propSort(order + 'title'));
                break;
            case 'SORT_WHEN':
                arr.sort(propSort(order + 'datetime_start'));
                break;
            case 'SORT_WHERE':
                arr.sort(propSort(order + 'city_town'));
                break;
            case 'SORT_DISTANCE':
                arr.sort(propSort(order + 'distance'));
                break;
        }

        return arr;
    }

    /**
     * Extract the details from the categories
     * @param  {Array}
     * @return {Array}
     */
    function extractDetailsFromCategories(categories) {
        var
            details = [],
            sorted, c, d;

        for (var i = categories.length - 1; i >= 0; i--) {
            c = categories[i];
            if (typeof c.details !== 'undefined' && c.details.length > 0) {
                sorted = c.details.sort(propSort('title'));
                for (var j = sorted.length - 1; j >= 0; j--) {
                    d = sorted[j];
                    d.day = moment(d.datetime_start).format('dd, L');
                    d.time = moment(d.datetime_start).format('hh:mm A') + ' - ' + moment(d.datetime_end).format('hh:mm A');
                    // Format according to ISO 8601, which is what Schema.org expects
                    d.datetime_start = moment(d.datetime_start).format();
                    d.datetime_end = moment(d.datetime_end).format();
                    details.push(d);
                }
            }
        }
        return details;
    }

    /**
     * Property Sort function
     * @param  {String}
     * @return {Array}
     */
    function propSort(prop) {
        var order = 1;
        if (prop[0] === "-") {
            order = -1;
            prop = prop.substr(1);
        }
        return function(a, b) {
            if (prop === 'distance') {
                a[prop] = parseFloat(a[prop]);
                b[prop] = parseFloat(b[prop]);
            }

            var result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
            return result * order;
        };
    }

    /**
     * Computer the distance between a and b, and returns it into the units
     * specified in preferences.measurement_unit
     * @param  {LatLng} a The from location
     * @param  {LatLng} b The to location
     * @return {int}      The distance between, either in kilometers or miles
     */
    function getDistanceBetween(a, b) {
        var distance = google.maps.geometry.spherical.computeDistanceBetween(a, b);

        // Divide, depending on the current measurement (km or mi)
        if (preferences.measurement_unit === 'mi') {
            distance /= 1609.344;
        } else {
            distance /= 1000;
        }

        return distance.toFixed(1);
    }

    /**
     * Returns the bounds of a circle, defined by the current search radius
     * @param  {LatLng} center The center to base the bounds of
     * @return {mixed}        False if no bounds could be calculated. LatLngBounds if it could.
     */
    function getBoundsByRadius(center) {
        var radius = 1000 * _STATES_.search.radius,
            circle;
        if (preferences.measurement_unit == 'mi') {
            radius = radius * 1.609344;
        }
        // If we have a radius above zero, calculate the bound.
        if (radius > 0) {
            circle = new google.maps.Circle({
                radius: radius,
                center: center
            });
            return circle.getBounds();
        }
        return false;
    }

    /**
     * Calculate the zoom level based on the supplied bounds and the dimensions of the map
     * @param  {LatLngBounds} bounds The bounds
     * @param  {Object} mapDim The dimensions of the map {width:,height:}
     * @return {int}        The zoom level to apply
     */
    function getZoomByBoundsAndMapDimensions(bounds, mapDim) {
        function latRad(lat) {
            var sin = Math.sin(lat * Math.PI / 180);
            var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }
        var WORLD_DIM = {
                height: 256,
                width: 256
            },
            ZOOM_MAX = 21,
            ne = bounds.getNorthEast(),
            sw = bounds.getSouthWest(),
            latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI,
            lngDiff = ne.lng() - sw.lng(),
            lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360,
            latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction),
            lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    /**
     * Finds the closest location based on the position given. Uses a filtered
     * location set.
     * @param  {LatLng} position The position to calculate from
     * @return {object}          The closest location found
     */
    function findClosestLocation(position) {
        var idx = -1,
            closest = Number.MAX_VALUE,
            // Make sure we use a filtered dataset
            details = filterAndSearchCategories(_DATA_.categories),
            distance;
        for (var i = details.length - 1; i >= 0; i--) {
            // Calculate the distance between the two points
            distance = getDistanceBetween(new google.maps.LatLng(details[i].lat, details[i].lng), position);
            if (distance < closest) {
                idx = i;
                closest = distance;
            }
        }
        // Return the location found
        return idx == -1 ? false : locations[idx];
    }

    /**
     * Returns a function, that, as long as it continues to be invoked, will not
     * be triggered. The function will be called after it stops being called for
     * N milliseconds. If `immediate` is passed, trigger the function on the
     * leading edge, instead of the trailing.
     * @param  {Fuction}  The function to be called
     * @param  {Number}   Milliseconds to wait for invocation
     * @param  {Boolean}  Whether or not to trigger on the leading edge
     * @return {Function}
     */
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    // Data Related Calls
    // --------------------------------------------------

    /**
     * Performs an ajax call and returns the data belonging to this instance
     * @return {object} Promise object
     */
    function loadInstanceData() {
        // Create the payload
        var payload = { action: 'get-calendar-details' };
        if (instanceId !== undefined) payload.instance_id = instanceId;
        if (categoryId !== undefined) payload.category_id = categoryId;
        if (netsuiteProviderSiteId !== undefined) payload.netsuite_provider_site_id = netsuiteProviderSiteId;
        // Perform the call
        return $.ajax({
            url: CCM_REL + '/index.php/tools/packages/calendar/ajax.php',
            data: payload,
            type: 'GET',
            dataType: 'json'
        });
    }

    /**
     * Geocodes a supplied address
     * @param  {string} address The address to geocode
     * @return {object} Promise object
     */
    function geocodeLocation(address) {
        var d = $.Deferred();
        geocoder.geocode({
            'address': address
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                d.resolve(results[0]);
            } else {
                d.reject('Could not geocode address: ' + address);
            }
        });
        return d.promise();
    }

    /**
     * Requests the users position and returns it on render
     * @return {object} Promise object
     */
    function getVisitorLocation() {
        var d = $.Deferred();
        navigator.geolocation.getCurrentPosition(function(results) {
            var position = new google.maps.LatLng(results.coords.latitude, results.coords.longitude);
            d.resolve(position);
        }, function(error) {
            d.reject(error);
        });
        return d.promise();
    }

    // Exposed methods
    // --------------------------------------------------

    return {
        init: init
    };

})(window, document, jQuery);

// Kick off the module after document ready
$(Booking.init);
